import { Link } from "react-router-dom";
import type { Title } from "@/types/media";
import TitleCard from "./TitleCard";

interface TitleGridProps {
  items: Title[];
  className?: string;
  highlight?: string;
}

export default function TitleGrid({ items, className = "", highlight }: TitleGridProps) {
  return (
    <div
      className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-5 ${className}`}
    >
      {items.map((item) => (
        <TitleCard key={item.id} item={item} highlight={highlight} />
      ))}
    </div>
  );
}